import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import useTableColumns from "./PackingLineTableConfig";
import {hasPackagingLinesFullAccess} from "../../helpers/jwt";
import AddButton from "../../components/button/AddButton";
import {useHistory} from "react-router-dom";
import FunctionalTableComponent from "../../components/table/FunctionalTableComponent";
import IconButton from "../../components/button/IconButton";
import {Button} from "react-bootstrap";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import { useTranslation } from 'react-i18next';

const PackingLineTablePage = (props) => {

    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);
    const models = useModels();

    const history = useHistory();

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("menu.packing_lines")}
                             parent={
                                 <LinkIconButton
                                     tooltip={t("menu.packing_lines")}
                                     icon={models.icons.line}
                                     link={"/lines"}
                                     props={props}
                                 />
                             }
                             subtitle={<>
                                 {hasPackagingLinesFullAccess() &&
                                     <Button
                                         variant={"outline-primary"}
                                         onClick={() => history.push("/machine-models")}
                                     >
                                         <i className="fa-solid fa-hard-drive mr-2"></i>
                                         {t("common.machine_models")}
                                     </Button>
                                 }



                             </>}
            >


                <FunctionalTableComponent
                    title={t("common.line_list")}
                    columns={useTableColumns()}
                    header={true}
                    api={"line"}
                    setLoader={setLoader}
                    readOnly={!hasPackagingLinesFullAccess()}
                    removable={true}
                    customCreate={() => history.push("/line")}
                    deleteModalTitle={t("forms.line_deletion")}
                    deleteModalDescription={t("forms.confirm_withdrawal")}
                    //todo remove line
                    editable={false}
                    additionalButtons={function (row) {
                        return <IconButton
                            variant={"outline-primary"}
                            onClick={() => {
                                history.push("/line/" + row.id);
                            }}
                            size={"sm"}
                            className={"px-3"}
                            tooltip={t("common.details")}
                            icon={"fa-arrow-right "}
                        />
                    }
                    }
                    width={12}
                />
            </CustomContainer>
        </>
    );
};

export default PackingLineTablePage;
